export default __webpack_public_path__ + "static/media/Fleshstripper Leggings.9e1d4d78.jpg";